<app-shell-home-ri [notificationsConfig]="notificationsConfig">
  <app-breadcrumb banner></app-breadcrumb>
</app-shell-home-ri>
